/* Sommaire latéral et bouton « retour en haut » des articles de blog.
   Le sommaire est bâti à partir des h2 réellement présents dans la page : il suit
   donc la langue de la locale, sans qu'aucune traduction ait à être touchée. */
(function(){
 // Sections d'appareil (sommaire, FAQ, récap, conclusion) : exclues du sommaire,
 // par leur ANCRE et non par leur libellé, qui change d'une langue à l'autre.
 var HORS = {sommaire:1, faq:1, 'fiche-recap':1, conclusion:1};
 function init(){
  var carte = document.querySelector('.mar-card'); if(!carte) return;
  var nav = document.querySelector('.mar-side'); if(!nav) return;
  var titres = [].slice.call(carte.querySelectorAll('h2[id]'))
                 .filter(function(h){ return !HORS[h.id]; });
  if(titres.length < 2){ nav.style.display='none'; return; }
  nav.innerHTML = '<p class="mar-toc-t">' + nav.getAttribute('data-titre') + '</p>'
    + titres.map(function(h){
        return '<a href="#'+h.id+'">'+h.textContent.trim()+'</a>'; }).join('');
  var liens = [].slice.call(nav.querySelectorAll('a'));
  // Mesure directe au défilement : requestAnimationFrame reste armé si l'onglet
  // est masqué, et le suivi ne repart jamais.
  function maj(){ var i, meilleur=-1, hautMax=-1e9, y;
   for(i=0;i<titres.length;i++){ y=titres[i].getBoundingClientRect().top;
     if(y<=150 && y>hautMax){ hautMax=y; meilleur=i; } }
   var actif = meilleur<0 ? 0 : meilleur;
   for(i=0;i<liens.length;i++) liens[i].className = (i===actif ? 'on' : '');
   var a=liens[actif]; if(!a) return;
   // .mar-side est en position:sticky, donc pas un offsetParent : on compare les
   // rectangles plutôt que d'utiliser offsetTop, qui serait faux.
   var ar=a.getBoundingClientRect(), nr=nav.getBoundingClientRect();
   if(ar.top<nr.top) nav.scrollTop += ar.top-nr.top-8;
   else if(ar.bottom>nr.bottom) nav.scrollTop += ar.bottom-nr.bottom+8; }
  window.addEventListener('scroll', maj, {passive:true});
  window.addEventListener('resize', maj); maj(); }

 function haut(){
  var b=document.querySelector('[data-haut]'); if(!b) return;
  b.addEventListener('click', function(e){ e.preventDefault();
   var y=window.scrollY,
       doux=!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
   try{ window.scrollTo({top:0, behavior: doux?'smooth':'auto'}); }
   catch(err){ window.scrollTo(0,0); }
   // Certains navigateurs ignorent « behavior » ; comme on a annulé le comportement
   // natif du lien, le bouton resterait inerte. Si RIEN n'a bougé au bout de 150 ms,
   // on remonte sèchement. Test d'absence TOTALE de mouvement, pour ne pas hacher
   // un défilement doux réellement en cours.
   setTimeout(function(){ if(window.scrollY===y && y>0){
     document.documentElement.scrollTop=0; document.body.scrollTop=0; } },150); }); }

 function tout(){ init(); haut(); }
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', tout);
 else tout();
})();
